import { Button, Loading } from '@brighterion/br-ui';
import React, { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import useCreateSingleReport from 'Hooks/query-hooks/reports/useCreateSingleReport';
import { useHistory } from 'react-router-dom';
import { SaveReportErrorModal } from './SaveReportErrorModal';

type Props = {
    extendedFormValues: ProcessedNewMerchantReportFormValues | undefined;
    setSaveBtnClicked: Dispatch<SetStateAction<boolean>>;
    reportType: ReportType;
};

const SaveReport = ({ extendedFormValues, setSaveBtnClicked, reportType }: Props) => {
    const { t } = useTranslation();
    const [errorModalOpen, setErrorModalOpen] = useState(false);
    const history = useHistory();
    const newReport = useCreateSingleReport({
        type: reportType,
        extendedFormValues,
        mutationOptions: {
            onSuccess: () => {
                history.push(`/reports?reportType=${reportType}`);
            }
        }
    });

    const exportCsvAction = () => {
        setSaveBtnClicked(true);
        newReport.mutate('');
    };

    return (
        <>
            {newReport.isLoading || newReport?.data?.status === 204 ? (
                <Loading size='sm' fillName='orange' />
            ) : (
                <Button
                    variant='primary'
                    size='small'
                    data-testid='save-to-report-list'
                    onClick={handleOnClickEvent(exportCsvAction)}
                    onKeyDown={handleKeyEvent(exportCsvAction)}
                    disabled={!extendedFormValues}
                >
                    {t('Save To Report List')}
                </Button>
            )}
            <SaveReportErrorModal
                isOpen={errorModalOpen}
                closeModal={() => {
                    newReport.reset();
                    setErrorModalOpen(false);
                }}
                createReport={() => newReport.mutate('')}
            />
        </>
    );
};

export default SaveReport;
